<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
    <div class="row mb-2">
        <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">

    <div class="row">
        <div class="col-12">
            <h4 class="mb-2 py-1 font-header-1">Location</h4>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col">
            <div widget class="card border-0 box-shadow">

                <div class="card-body  widget-body pb-0 pt-2 mb-4">
                    <div class="row mt-2">
                        <div class="col-6">
                            <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal"
                                data-bs-target="#Createmodal"
                                (click)="CreateorUpdateLocationList('CreatelocationModal')"
                                *ngIf="fp.locationcreate">Add
                                Location</button>
                        </div>
                        <div class="col-6 ">
                            <button type="button" class="btn  btn-sm text-right" (click)="clearLocation('refresh')">
                                <i class="fa fa-repeat"> Refresh </i>
                            </button>
                        </div>
                    </div>

                    <div class="row mt-2"
                        *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
                global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000') || (global.agencyCode!='SUPERADMIN')">
                        <div class="col pt-2">
                            <!-- ejs-grid -->
                            <ejs-grid #gridLocation [dataSource]='GridList | async' [allowPaging]='true'
                                (dataStateChange)='dataChangeLocation($event)' (actionBegin)="onActionLocation($event)"
                                [showColumnChooser]='true' [pageSettings]='initialPage'
                                [filterSettings]='filterSettings' [allowFiltering]='true' [allowResizing]='true'
                                [allowSorting]='true'>
                                <e-columns>
                                    <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                                        <ng-template #template let-data>
                                            <button class="btn btn-edit-table" data-bs-toggle="modal"
                                                data-bs-target="#Createmodal"
                                                (click)="CreateorUpdateLocationList('UpdatelocationModal');getDetails(data)"
                                                *ngIf="fp.locationupdate"><i class="fa fa-edit"></i></button>&nbsp;
                                            <button class="btn btn-delete-table" data-bs-target="#deleteLocationmodal"
                                                data-bs-toggle="modal" (click)="getDetails(data)"
                                                *ngIf="fp.locationdelete"><i class="fa fa-trash"></i></button>
                                        </ng-template>
                                    </e-column>
                                    <e-column minWidth=100 field="name" headerText="Location Name" type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column minWidth=100 field="weekStartDayLovName" headerText="Week Start Day"
                                        type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column minWidth=100 field="weekEndDayLovName" headerText="Week End Day"
                                        type="string">
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column width="50" [showInColumnChooser]='false'>
                                        <ng-template #headerTemplate let-data>
                                            <div>
                                                <span id='show' (click)='showLocationColumns()'><i
                                                        class="fa fa-cog fa-lg" aria-hidden="true">
                                                    </i></span>
                                            </div>
                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- For Create or Update Modal -->
<span id="openLocationModal" data-bs-toggle="modal" data-bs-target="#Createmodal"></span>
<div class="modal fade" id="Createmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span
                        *ngIf="LocationType == 'CreatelocationModal'"> Create
                        Location</span>
                    <span *ngIf="LocationType == 'UpdatelocationModal'">Update Location</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="width: 13px;">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="LocationForm">
                    <div class="row">
                        <div class="col-lg-5">
                            <label>Name<sup class="super-script">*</sup>
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" formControlName="LocationName" class="form-control"
                                [(ngModel)]="saveLocation.name" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-5">
                            <label>Week Day Start<sup class="super-script">*</sup>
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <ng-select class="col-12 mt-1" [(ngModel)]="saveLocation.weekStartDayLid"
                                formControlName="StartDayName" style=" color: black;" [clearable]="false"
                                [searchable]="true" (change)="daychange()" [items]="LocationDropdown"
                                bindLabel="lovName" bindValue="id">
                            </ng-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-5">
                            <label>Week Day End
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <ng-select class="col-12 mt-1" [(ngModel)]="saveLocation.weekEndDayLid"
                                formControlName="EndDayName" style=" color: black;" [clearable]="false"
                                [searchable]="true" [items]="LocationDropdown" [disabled]="true" bindLabel="lovName"
                                bindValue="id">
                            </ng-select>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="SaveOrUpdateLocation();"
                    [disabled]="!LocationForm.valid || this.saveLocation.weekStartDayLid === 0 || isSaveorUpdateBoolean"><span
                        *ngIf="LocationType == 'CreatelocationModal'"> Save &
                        Close</span> <span *ngIf="LocationType == 'UpdatelocationModal'">Update & Close</span> </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="clearLocation('cancel')">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- For Delete Modal -->
<span id="closeLocationModal" data-bs-target="#deleteLocationmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteLocationmodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clearLocation('cancel')"
                    aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteLocation()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="clearLocation('cancel')">No</button>
            </div>
        </div>
    </div>
</div>